


























import TreeView from '@/components/display/tree.vue';
import RawDataTable from './raw-data-table.vue';

import { capitalize } from '@amcharts/amcharts4/.internal/core/utils/Utils';
import { Transceiver } from '@/api';
import { chimeraRawDataTypeValues, classicRawDataTypeValues } from './raw-data-utils';
import { Vue, Emit, Prop, Component } from 'vue-property-decorator';

@Component({
	methods: { capitalize },
	components: {
		TreeView,
		RawDataTable,
	},
})
export default class RawData extends Vue {
	@Prop({ type: Object })
	public transceiver?: Transceiver;

    public rawDataValues: string[] = this.getTabItems();
	public filter: string = '';

	public get transceiverId(): number {
		return this.transceiver?.id || 0;
	}

	@Emit('reload')
	public reload() {}

    public getTabItems(): string[] {
        return this.transceiver?.isClassic
            ? classicRawDataTypeValues
            : chimeraRawDataTypeValues;
    }

	public handleSearch(vertex: any) {
		this.filter = vertex.entity.uniqueId;
	}
}
